<template>
    <div class="blackBg animate__animated animate__bounceIn">
        <div class="cardTit">
            <span class="teamName">{{ teamName ? teamName : 'XXX' }}</span>
        </div>
        <div class="cardBg">
            <p class="userName">{{ this.$route.params.name }}</p>
            <ul class="label">
                <li v-for="item in colors">
                    <i :style="{background: item.color}"></i>
                    <span>{{ item.value }}</span>
                </li>
            </ul>
            <div class="GPS-AIM-bar-content clearfix" id="cardBg" @click="clearTimeFn">
                <div class="contentBox">
                    <div class="barBox scrollX" v-for="(item, index) in AIMItem">
                        <p>{{ item.displayName }}</p>
                        <div :key="index" class="GPS-AIM-bar-item" :id="'GPS-AIM-bar-'+index"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "match_day_detail",
    data() {
        return {
            teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
            AIMData: [],
            AIMItem: [],
            checkName: '',//选中的标签 比如跑动距离
            time: null,//上下滚动定时器
            scrollDomHeight: 0,//dom高度
            colors: [
                {color: "#FFC700", value: "M-4", name: '（M-4比赛日前4天）'},
                {color: "#00D190", value: "M-3", name: '（M-3比赛日前3天）'},
                {color: "#3663E1", value: "M-2", name: '（M-2比赛日前2天）'},
                {color: "#FF5630", value: "M-1", name: '（M-1比赛日前1天）'},
                {color: "#7E45FF", value: "M", name: 'M'},
            ],
            matchData: [],
            dateArr: []
        }
    },
    computed: {
        teamId() {
            return this.$store.state.teamId;
        }
    },
    watch: {},
    mounted() {
        this.getFilter()
    },
    methods: {
        //  获取gps 筛选项
        getFilter() {
            let data = {
                teamId: this.teamId
            }
            this.$server.getGpsFilter(data).then(res => {
                if (res.code === 200) {
                    this.AIMItem = [];
                    if (res.data && res.data.length) {
                        let arr = [];
                        res.data.map(item => {
                            if (item.gps) {
                                // console.log(item.slug)
                                arr.push(item)
                            }

                        })
                        this.AIMItem = arr;
                        this.getAIM()
                    }
                }
            })
        },
        getAIM() {
            let data = {
                playerId: this.$route.params.id,
                teamId: this.teamId,
                startDate: new Date().getFullYear()-1 + '/01/01',
                endDate: this.$global.formatDate(new Date(), 'yyyy/MM/dd', true)
            }
            this.$server.getMatch_dateReport(data).then((res) => {
                if (res.code == 200) {
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.$route.params.name + '的比赛日报告'), true, false)

                    let AIMData = res.data;
                    this.matchData = Object.values(AIMData)
                    this.dateArr = Object.keys(AIMData);

                    if (this.matchData.length) {
                        this.AIMBar();
                    }

                    //默认显示
                    setTimeout(() => {
                        this.scroll();
                    }, 2000)
                }
            })
        },
        //echarts图
        AIMBar(data, id) {


            const arr = [...this.colors]
            arr.reverse();

            this.AIMItem.forEach((item, index) => {
                let dom = document.getElementById('GPS-AIM-bar-' + index);
                let myChart = this.$echarts.init(dom);
                let option = null;


                let barData = [];
                let series = [];

                const matchData = []
                for (let i = 0; i < arr.length; i++) {
                    let emptyArr = new Array(this.AIMItem.length).fill(0)
                    matchData.push(emptyArr)
                }

                this.matchData.forEach((match, i1) => {
                    match.forEach((matchDay, i2) => {
                        let obj = matchDay.data.find(slugItem => slugItem.slug === item.slug)
                        if (obj) {
                            matchData[i2][i1] = Number(obj.value || 0).toFixed(item.decimal || 2)
                        }
                    })
                })

                arr.forEach((colorItem, colorIndex) => {
                    barData.push({
                        ...colorItem,
                        data: matchData[colorIndex]
                    })
                })

                console.log(barData)

                let lookDom = document.getElementById('GPS-AIM-bar-' + index);
                //柱状图显示宽度
                if (parseInt(lookDom.offsetWidth) > (10 * barData[0].data.length)) {
                    dom.style.width = (parseInt(lookDom.offsetWidth)) + 'px';
                } else {
                    dom.style.width = (10 * barData[0].data.length) + "px";
                }
                myChart.resize();

                //遍历所得到的数据，分别创建不同的bar->series
                barData.forEach((itemChild) => {
                    series.push(
                        {
                            type: 'bar',
                            name: item['name'],
                            barGap: .5,
                            showBackground: true,
                            backgroundStyle: {
                                color: 'rgba(27, 27, 27, 0.1)',
                                opacity: '0.5',
                                borderRadius: 2,
                            },
                            itemStyle: {
                                normal: {
                                    borderRadius: [2],
                                    color: (params) => {
                                        return params.data.color
                                    }
                                }
                            },
                            data: itemChild.data.map(item => {
                                return {
                                    value: Number(item) > 0 ? item : '',
                                    name: itemChild.name,
                                    key: itemChild.value,
                                    color: itemChild.color,
                                }
                            }),
                            z: 100,
                            barWidth: 20,
                            label: {
                                show: true,
                                rotate: '90',
                                position: 'top',
                                align: 'left',
                                verticalAlign: 'middle',
                                distance: '5',
                                color: itemChild.color,
                                fontSize: 18,
                                formatter: function (params) {
                                    return [
                                        params.value,
                                        '{matchKey|' + params.data.key + '}',
                                    ].join('  ');
                                },
                                rich: {
                                    matchKey: {
                                        color: '#787885',
                                        fontSize: 18,
                                        fontFamily: 'AkrobatRegular',
                                    },
                                },
                            },
                        },
                    )
                })


                option = {
                    grid: {
                        top: '80',
                        left: '30',
                        right: '30',
                        bottom: '15%',
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            show: true,
                            type: "category",
                            data: this.dateArr,
                            axisLine: {
                                show: true,  // 是否显示
                                lineStyle: {
                                    color: '#666',
                                    opacity: '0.5',
                                    type: 'solid'
                                },
                            },
                            axisLabel: {
                                //坐标轴刻度标签的相关设置。
                                show: true,
                                textStyle: {
                                    color: '#B7B7BF',
                                    fontSize: 20
                                },
                                margin: 15,
                            },
                            axisTick: {
                                show: false
                            },
                            splitLine: {
                                lineStyle: {
                                    color: '#666',
                                    opacity: '0.3',
                                    type: 'dotted'
                                },
                                show: true
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            show: true,
                            min: 0,
                            splitLine: {
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, .3)',
                                    type: 'dotted'
                                },
                                show: true
                            },
                            axisLabel: {
                                //坐标轴刻度标签的相关设置。
                                show: true,
                                textStyle: {
                                    color: 'rgba(255, 255, 255, .5)',
                                    fontSize: 20
                                },
                            },
                        }
                    ],
                    series: series
                };

                if (option && typeof option === "object") {
                    myChart.setOption(option, true);
                }
            })

        },
        //滚动数据
        scroll() {
            var hScrollTop = document.getElementById('cardBg').scrollTop;
            var hScrollHeight = document.getElementById('cardBg').scrollHeight;
            var offsetHeight = document.getElementById('cardBg').offsetHeight;

            // console.log(hScrollTop + " " + hScrollHeight + " " + this.height + ' ' + offsetHeight);
            if ((offsetHeight + hScrollTop) >= hScrollHeight) {//滚动条已经到了容器底部
                this.height = -1;
            }else if (hScrollTop === 0) {
                this.height = 1;
            }

            var h = hScrollTop + this.height;
            document.getElementById('cardBg').scrollTop = h;
            this.time = window.requestAnimationFrame(this.scroll)
        },
        clearTimeFn() {
            console.log('执行取消事件')
            window.cancelAnimationFrame(this.time)
            return false;
        },
    },
    destroyed() {
        window.cancelAnimationFrame(this.time)
    }
}
</script>

<style scoped lang="less">
.cardTit {
    background-image: url("../../assets/img/updateImg/head_2.png");
    font-size: 30px;
    box-sizing: border-box;
    position: relative;


}

.cardBg {
    width: 100%;
    height: calc(100% - (120px + 1.2vw));
    padding: 1vw;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;

    .userName {
        color: var(--primary-color);
        font-size: 36px;
        height: 3vw;
        line-height: 2vw;
        padding-left: 1vw;
    }

    .label {
        position: absolute;
        right: 2vw;
        top: 2vw;
        font-size: 18px;
        li {
            float: left;
            margin-right: 1vw;
            i {
                width: .7vw;
                height: .7vw;
                display: inline-block;
                margin-right: .5vw;
            }
        }
    }
}

.GPS-AIM-bar-content {
    width: 100%;
    height: calc(100% - 3vw);
    overflow-y: auto;

    .barBox {
        width: 100%;
        height: 400px;
        overflow-y: hidden;
        overflow-x: hidden;
        margin-top: 1.5vw;
        padding-left: 1.5vw;

        p {
            font-size: 24px;
            color: #fff,
        }

        .GPS-AIM-bar-item {
            height: 100%;
            width: 100%;
        }
    }

    .scrollX {
        overflow-x: scroll;
    }
}
</style>
